import type { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  FormButtons,
  FormLayout,
  FormSection
} from '@/components/common/FormGrid/FormGrid'

import styles from './SectionForm.module.scss'
import SectionFormCourse from './SectionFormCourse'
import SectionFormSelects from './SectionFormSelects'
import type { SectionFormValues } from '../../hooks/useSectionForm'

type SectionFormProps = {
  form: UseFormReturn<SectionFormValues>
  onSubmit: (formValues: SectionFormValues) => void
}

const SectionForm = (props: SectionFormProps) => {
  const { t } = useTranslation('sections')

  return (
    <FormLayout
      className={styles.container}
      form={props.form}
      onSubmit={props.onSubmit}
    >
      <FormSection header={t('header.curriculum-and-course')}>
        <SectionFormSelects />
        <SectionFormCourse />
      </FormSection>

      <FormButtons />
    </FormLayout>
  )
}

export default SectionForm
